import { cn } from "../lib/utils";
import { Factory, Building2 } from "lucide-react";

export const DESTINATION_FULL_LABEL = {
  Monterrey: "Monterrey Vertiv Plant",
  Apodaca: "Apodaca Vertiv Office",
};

export function DestinationBadge({ destination, size = "md", full = false, className }) {
  const isMonterrey = destination === "Monterrey";
  const Icon = isMonterrey ? Factory : Building2;
  const styles = isMonterrey
    ? "bg-emerald-900/30 text-emerald-300 border-emerald-700/50"
    : "bg-amber-900/30 text-amber-300 border-amber-700/50";

  // Show full label automatically on lg, or if explicitly requested
  const shouldShowFull = full || size === "lg";
  const label = shouldShowFull ? (DESTINATION_FULL_LABEL[destination] || destination) : destination;

  const sizes = {
    sm: "text-xs px-2 py-0.5 gap-1",
    md: "text-xs px-2.5 py-1 gap-1.5",
    lg: "text-sm px-3.5 py-1.5 gap-2",
  };

  return (
    <span
      data-testid={`destination-badge-${destination?.toLowerCase()}`}
      className={cn(
        "inline-flex items-center rounded-full border backdrop-blur-md font-semibold whitespace-nowrap",
        styles,
        sizes[size],
        className
      )}
    >
      <Icon className={cn(size === "lg" ? "h-4 w-4" : "h-3 w-3")} />
      {label}
    </span>
  );
}
